import uikit from "./directives/uikit/index.js";
import clickable from "./directives/clickable/index.js";

export default function uikitDirectives(Alpine) {
    uikit(Alpine);
    clickable(Alpine);
}